<template>
	<div>
		<el-tag type="info" disable-transitions :closable="customer ? true : false" @click="checkCustomerShow = true" @close="clearCustomer" style="cursor: pointer;">
			<span v-if="customer">{{ customer.name }}</span>
			<span v-else>
				点击选择
				<i class="el-icon-arrow-down"></i>
			</span>
		</el-tag>
		<check-customer :show="checkCustomerShow" :current="customer" @close="checkCustomerShow = false" @check="changeCheckCustomer"></check-customer>
	</div>
</template>

<script>
import checkCustomer from '@/components/check-customer.vue';
export default {
	components: { checkCustomer },
	name: 'form-item-customer',
	model: {
		prop: 'id',
		event: 'changeId'
	},
	props: {
		id: {
			type: String,
			default: () => {
				return '';
			}
		},
		config: {
			type: Object,
			default: () => {
				return {};
			}
		}
	},
	data() {
		return {
			checkCustomerShow: false,
			configData: {},
			customer: null
		};
	},
	beforecreate: function() {},
	created: function() {},
	mounted() {
		this.configData = this.config;
	},
	updated: function() {},
	methods: {
		changeCheckCustomer(e) {
			this.customer = e;
			this.$emit('change', e);
			this.$emit('changeId', e.id);
		},
		clearCustomer() {
			this.customer = null;
			this.$emit('change', null);
			this.$emit('changeId', '');
		}
	},
	watch: {}
};
</script>

<style></style>
